<template>
  <div class="mb-3 overflow-auto max-h-52 min-h-40">
    <div
      class="folder-item pb-2"
      :class="folderMarginLeftClass(folder)"
      :key="folder.folderId"
      v-for="(folder) in folders"
    >
      <div class="flex items-center mb-2">
        <div class="mr-1">
          <aha-icon
            name="folder"
            width="19"
            height="19"
            viewBox="0 0 24 24"
            class="text-purple-50"
          />
        </div>
        <div class="text-sm text-base-90 font-bold">
          {{ folder.folderName }}
        </div>
      </div>

      <div
        :class="presentation.id === selectedPresentationId
          ? 'presentation-item--active'
          : 'presentation-item'"
        :key="presentation.id"
        @click="handlePresentationItemClick(presentation)"
        v-for="
          (presentation) in allowToCopyToPresentations
            .filter((item) => item.folderId === folder.folderId)
        "
      >
        <input
          class="mr-2 cursor-pointer"
          type="radio"
          :checked="presentation.id === selectedPresentationId"
        >
        <span class="truncate">{{ presentation.name }}</span>
        <span class="ml-1 text-base-70">({{ presentation.accessCode }})</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    selectedPresentationId: {
      type: Number,
      default: null,
    },
    folders: {
      type: Array,
      default: () => [],
    },
    allowToCopyToPresentations: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    folderMarginLeftClass() {
      return (folder) => {
        const { depth } = folder
        const marginLeft = depth + 5 * depth || 0
        return `ml-${marginLeft}`
      }
    },
  },
  methods: {
    handlePresentationItemClick(presentation) {
      this.$emit('handlePresentationItemClick', presentation)
    },
  },
}
</script>

<style lang="scss" scoped>
.folder-item {
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }
}
.ml-12 {
  margin-left: 3rem;
}
.ml-18 {
  margin-left: 4.5rem;
}
.ml-24 {
  margin-left: 6rem;
}
.ml-30 {
  margin-left: 7.5rem;
}
.ml-36 {
  margin-left: 9rem;
}
.ml-42 {
  margin-left: 10.5rem;
}
.ml-48 {
  margin-left: 12rem;
}
.ml-54 {
  margin-left: 13.5rem;
}
.ml-60 {
  margin-left: 15rem;
}
.presentation-item,
.presentation-item--active {
  padding: 0.5rem 0.75rem 0.5rem 0.5rem;
  margin-left: 1rem;
  cursor: pointer;
  transition: 250ms all ease-in-out;
  display: flex;
  align-items: center;
}
.presentation-item--active {
  background-color: rgb(231, 232, 235);
}
.presentation-item:hover {
  background-color: rgba(231, 232, 235, 0.5);
}
</style>
